module.exports = __webpack_public_path__ + "./fonts/fontawesome-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/fontawesome-webfont.svg?v=4.6.3
// module id = 18
// module chunks = 0